import React from 'react';
import { 
    CopyrightDiv, 
    CopyrightText 
} from '../../Styles/BaseStyles'

function Copyright(props) {
    return (
        <CopyrightDiv id="copyright-section" className = "light">
            <CopyrightText>&copy;QuickFiller, 2021. All rights reserved.</CopyrightText>
        </CopyrightDiv>
    )
}

export default Copyright;